import React from 'react';
import { Download, Utensils, ActivitySquare } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-8 h-8 text-orange-600" data-id="element-87" />,
    title: 'Paso 1',
    description: 'Descargue el protocolo inmediatamente en su teléfono, tableta o computadora.'
  }, {
    icon: <Utensils className="w-8 h-8 text-orange-600" data-id="element-88" />,
    title: 'Paso 2',
    description: "Aplique el 'Orden Metabólico' en su próxima comida de hoy mismo."
  }, {
    icon: <ActivitySquare className="w-8 h-8 text-orange-600" data-id="element-89" />,
    title: 'Paso 3',
    description: 'Siga el checklist de 24 horas y sienta cómo la pesadez desaparece en los primeros 3 días.'
  }];
  return <section className="py-20 bg-orange-50 border-y border-orange-100" data-id="element-90">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="max-w-4xl mx-auto text-center" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-16" data-id="element-93">
            Cómo funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-94">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 bg-orange-200 z-0" data-id="element-95"></div>

            {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center" data-id="element-96">
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-orange-100 mb-6" data-id="element-97">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-98">
                  {step.title}
                </h3>
                <p className="text-gray-700 leading-relaxed px-4" data-id="element-99">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}